import { useEffect, useRef } from 'react'
import { type Location, useLocation } from 'react-router'

function useRouteChangeEffect(
	callback: (location: Location) => void,
	deps: (keyof Location)[] = ['pathname'], // Only watch specific location properties
) {
	const location = useLocation()
	const callbackRef = useRef(callback)

	// Update callback ref without causing re-renders
	callbackRef.current = callback

	useEffect(
		() => {
			callbackRef.current(location)
		},

		// eslint-disable-next-line react-hooks/exhaustive-deps
		deps.map(
			(dep) =>
				// @ts-ignore
				location[dep],
		),
	)
}
export { useRouteChangeEffect }
